async function request(path, options = {}) {
  const headers = new Headers(options.headers)
  if (!(options.body instanceof FormData) && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json')
  const response = await fetch(`/api${path}`, {
    credentials: 'same-origin',
    ...options,
    headers,
  })
  if (!response.ok) {
    const contentType = response.headers.get('content-type') || ''
    const data = contentType.includes('application/json') ? await response.json() : {}
    const error = new Error(data.error || 'Có lỗi xảy ra, vui lòng thử lại.')
    error.status = response.status
    error.data = data
    throw error
  }
  return response
}

export async function api(path, options = {}) {
  const response = await request(path, options)
  return (response.headers.get('content-type') || '').includes('application/json') ? response.json() : {}
}

export async function downloadFile(path, filename) {
  const response = await request(path)
  const url = URL.createObjectURL(await response.blob())
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  try { link.click() }
  finally {
    link.remove()
    setTimeout(() => URL.revokeObjectURL(url), 1000)
  }
}
